import React from "react";
import AnimationRevealPage from "helpers/AnimationRevealPage.js";
import { Container, ContentWithPaddingXl } from "components/misc/Layouts";
import tw from "twin.macro";
import styled from "styled-components";
import Header from "components/headers/light.js";
import Footer from "components/footers/FiveColumnWithInputForm.js";
import { SectionHeading } from "components/misc/Headings";

const HeadingRow = tw.div`flex`;
const Heading = tw(SectionHeading)`text-gray-900`;
const Text = styled.div`
  ${tw`text-lg text-gray-800`}
  p {
    ${tw`mt-2 leading-loose`}
  }
  h2 {
    ${tw`text-xl font-bold mt-6`}
  }
  h3 {
    ${tw`text-lg font-bold mt-4`}
  }
  h4 {
    ${tw`text-base font-bold mt-3`}
  }
  ul {
    ${tw`list-disc list-inside mt-3`}
  }
  ol {
    ${tw`list-decimal list-inside mt-3`}
  }
`;

export default ({ headingText = "Política de Privacidade" }) => {
  return (
    <AnimationRevealPage>
      <Header />
      <Container>
        <ContentWithPaddingXl>
          <HeadingRow>
            <Heading>{headingText}</Heading>
          </HeadingRow>
          <Text>
            <p>
              A TRATAZ – Tratamentos Digitalizados de A a Z ("TRATAZ") também
              tem a missão de assegurar a privacidade dos dados pessoais
              coletados para realização das suas atividades, com o devido
              cumprimento à Lei Geral de Proteção de Dados Pessoais (Lei
              13.709/18) (a "LGPD") e demais normas, legislações e regulamentos
              aplicáveis ao tratamento de dados pessoais.
            </p>
            <p>
              O objetivo desta política é a definição de processos, técnicas e
              medidas organizacionais adequadas ao tratamento de dados, contra
              perda, dano ou destruição acidental de dados pessoais, e, assim,
              garantir que os dados pessoais estejam protegidos e possibilitar o
              exercício de direitos pelos titulares.
            </p>
            <p>
              Quaisquer dúvidas sobre a legislação aplicável, sobre
              procedimentos ou solicitações que envolvam o tratamento de dados
              pessoais pela TRATAZ podem ser direcionadas ao endereço
              eletrônico: contato@trataz.com.
            </p>

            <h2>1. DEFINIÇÕES:</h2>
            <h3>
              1.1. Para fins desta Política de Privacidade, consideram-se:
            </h3>
            <p>
              a) Dados Pessoais: Qualquer informação relacionada a uma pessoa
              natural identificada ou identificável. Isso inclui, mas não se
              limita a, nome, identificação, dados de saúde, informações de
              contato e dados eletrônicos como endereços IP e cookies.
            </p>
            <p>
              b) Dados Sensíveis: Dados pessoais que revelam origem racial ou
              étnica, convicções religiosas, opiniões políticas, filiação
              sindical, dados genéticos, biométricos ou relacionados à saúde ou
              à vida sexual de uma pessoa natural.
            </p>
            <p>
              c) Titular dos Dados: A pessoa natural a quem se referem os dados
              pessoais.
            </p>
            <p>
              d) Tratamento: Qualquer operação realizada com dados pessoais,
              tais como coleta, registro, organização, estruturação,
              armazenamento, adaptação ou alteração, recuperação, consulta, uso,
              divulgação por transmissão, disseminação ou disponibilização,
              alinhamento ou combinação, restrição, exclusão ou destruição.
            </p>
            <p>
              e) Controlador: Pessoa natural ou jurídica, de direito público ou
              privado, que determina as finalidades e os meios de tratamento de
              dados pessoais.
            </p>
            <p>
              f) Operador: Pessoa natural ou jurídica, de direito público ou
              privado, que trata dados pessoais em nome do controlador.
            </p>
            <p>
              g) Encarregado de Dados (Data Protection Officer - DPO): Pessoa
              indicada pelo controlador para atuar como canal de comunicação
              entre o controlador, os titulares dos dados e a Autoridade
              Nacional de Proteção de Dados (ANPD).
            </p>
            <p>
              h) Consentimento: Manifestação livre, informada e inequívoca pela
              qual o titular dos dados concorda com o tratamento de seus dados
              pessoais para uma ou mais finalidades específicas.
            </p>
            <p>
              i) Autoridade Nacional de Proteção de Dados (ANPD): Órgão da
              administração pública responsável por zelar, implementar e
              fiscalizar o cumprimento da LGPD em todo o território nacional.
            </p>
            <p>
              j) Violação de Dados Pessoais: Brecha de segurança que acarreta,
              de forma acidental ou ilícita, a destruição, perda, alteração,
              divulgação ou acesso não autorizado a dados pessoais transmitidos,
              armazenados ou de outra forma tratados.
            </p>

            <h2>2. DADOS PESSOAIS:</h2>
            <p>
              2.1. Ao ACEITAR esta POLÍTICA DE PRIVACIDADE, você CONCORDA que a
              TRATAZ fica autorizada a tomar decisões referentes ao tratamento e
              a realizar o tratamento dos dados pessoais fornecidos pelo titular
              na plataforma da TRATAZ, no sítio eletrônico https://trataz.com.
            </p>

            <h3>2.2. Em específico os Dados:</h3>
            <p>
              a) Nome e Sobrenome;
              <br />
              b) Data de nascimento;
              <br />
              c) Número do Cadastro de Pessoas Físicas – CPF;
              <br />
              d) Endereço completo;
              <br />
              e) Números de telefone, WhatsApp, e endereços eletrônicos;
              <br />
              f) Data de Nascimento, idade, aniversário;
              <br />
              g) Fotografia (opcional);
              <br />
              h) Tratamento e Histórico do Paciente;
              <br />
              i) Nome de usuário e senha específicos para uso dos serviços do
              Controlador; e<br />
              j) Comunicação, verbal e escrita, mantida entre o Titular e o
              Controlador, que possa identificar o Titular.
            </p>

            <h2>3. FINALIDADE:</h2>
            <p>
              3.1. Esta Política de Privacidade estabelece os princípios e
              pautas de atuação que regem esta organização em matéria de
              privacidade e proteção de dados pessoais, garantindo, em todo
              caso, o cumprimento da legislação aplicável.
            </p>
            <p>
              3.2. A TRATAZ se compromete a tratar os dados pessoais
              exclusivamente para finalidades claras e legítimas, detalhadamente
              descritas abaixo:
            </p>

            <h3>3.2.1. Gestão de Tratamento de Pacientes:</h3>
            <p>
              Utilizamos os dados pessoais coletados para possibilitar aos
              profissionais de saúde, especificamente fonoaudiólogos e
              odontólogos, gerenciar de maneira eficiente o tratamento de seus
              pacientes. Aqui também inclui o registro de informações de saúde,
              acompanhamento de progresso, personalização de tratamentos e
              comunicação efetiva entre profissionais e pacientes.
            </p>

            <h3>3.2.2. Desenvolvimento e Oferta de Materiais Educativos:</h3>
            <p>
              Os dados pessoais são tratados para permitir a criação e oferta de
              materiais educativos personalizados, incluindo vídeos
              explicativos, exercícios, quizes e relatórios, destinados a apoiar
              o tratamento dos pacientes e a promoção de práticas saudáveis.
              Tais dados auxiliam na elaboração de conteúdos que facilitam a
              comunicação e o entendimento durante as pré e pós consultas,
              melhorando a experiência e o engajamento dos pacientes.
            </p>

            <h3>3.2.3. Aprimoramento e Personalização do Serviço:</h3>
            <p>
              Os dados pessoais são utilizados para aprimorar continuamente
              nossos serviços e plataformas virtuais, garantindo uma experiência
              personalizada e eficaz para os profissionais de saúde e seus
              pacientes, o que também inclui a personalização de interfaces, a
              otimização da usabilidade e a adaptação de funcionalidades com
              base nas preferências e comportamentos dos usuários.
            </p>

            <h3>3.2.4. Comunicação e Suporte ao Usuário:</h3>
            <p>
              Utilizamos os dados para facilitar a comunicação entre a TRATAZ e
              os usuários, oferecendo suporte técnico, respondendo a consultas e
              enviando atualizações importantes sobre o serviço. Isso também
              inclui a utilização dos dados para o envio de materiais
              informativos e educativos, bem como notificações sobre novidades
              ou mudanças nos nossos serviços.
            </p>

            <h3>3.2.5. Análise e Pesquisa:</h3>
            <p>
              Os dados coletados são analisados para conduzir pesquisas e
              estudos que visam melhorar o entendimento das necessidades dos
              profissionais de saúde e pacientes, desenvolver novas
              funcionalidades e serviços e contribuir para a evolução do setor
              de saúde digital.
            </p>

            <h3>3.2.6. Conformidade Legal e Regulatória:</h3>
            <p>
              Os dados pessoais são tratados para garantir a conformidade da
              TRATAZ com as leis e regulamentações aplicáveis, incluindo, mas
              não se limitando, à gestão de registros e ao atendimento de
              solicitações legais e regulatórias de autoridades competentes.
            </p>

            <h3>
              3.3. Além das finalidades específicas acima, também são
              finalidades o tratamento dos dados pessoais pela TRATAZ:
            </h3>
            <p>
              3.3.1. Possibilitar que a Controladora identifique e entre em
              contato com o Titular para fins de relacionamento comercial;
              <br />
              3.3.2. Possibilitar que a Controladora elabore contratos
              comerciais e emita eventuais cobranças em nome do Titular;
              <br />
              3.3.3. Possibilitar que a Controladora envie ou forneça ao Titular
              seus produtos e serviços, de forma remunerada ou gratuita;
              <br />
              3.3.4. Possibilitar que a Controladora estruture, teste, promova e
              faça propaganda de produtos e serviços, personalizados ou não ao
              perfil do Titular;
              <br />
              3.3.5. Possibilitar que a Controladora utilize tais dados em
              Pesquisas de Mercado;
              <br />
              3.3.6. Possibilitar que a Controladora utilize tais dados na
              elaboração de relatórios, emissão e melhoria de produtos e
              serviços;
              <br />
              3.3.7. Possibilitar que a Controladora utilize tais dados para
              suas peças de Comunicação;
              <br />
              3.3.8. Possibilitar que a Controladora utilize tais dados emissão
              de Notas Fiscais e documentos financeiros correlatos;
              <br />
              3.3.9. Possibilitar que a Controladora utilize tais dados para
              facilitar a prestação de serviços diversos além dos primariamente
              contratados, desde que o titular também demonstre interesse em
              contratar novos serviços.
            </p>

            <h2>4. PRINCÍPIOS DO TRATAMENTO DOS DADOS PESSOAIS:</h2>
            <p>
              4.1. Os princípios pelos quais se rege a presente Política são os
              seguintes:
            </p>

            <h3>4.1.1. Princípios gerais:</h3>
            <p>
              a) Todos os integrantes da organização cumprirão a legislação
              aplicável em matéria de proteção de dados, a que resulte em função
              do tratamento de dados pessoais que se realize e a que se
              determine conforme normas ou acordos vinculantes adotados no
              âmbito da TRATAZ.
            </p>
            <p>
              b) A administração atuará para que os princípios abrangidos nesta
              Política sejam cumpridos:
            </p>
            <ul>
              <li>
                No desenho e implementação de todos os procedimentos que
                impliquem o tratamento de dados pessoais;
              </li>
              <li>Nos serviços oferecidos;</li>
              <li>Em todos os contratos e obrigações formalizados; e</li>
              <li>
                Na implantação dos sistemas e plataformas que permitam o acesso
                por parte de colaboradores ou de terceiros a dados pessoais e/ou
                o recolhimento ou tratamento desses dados.
              </li>
            </ul>

            <h3>
              4.1.2. Princípios relativos ao tratamento de dados pessoais:
            </h3>
            <p>
              a) As atividades de tratamento de dados pessoais deverão observar
              a boa-fé e os seguintes princípios:
            </p>
            <ul>
              <li>
                Finalidade: realização do tratamento para propósitos legítimos,
                específicos, explícitos e informados ao titular, sem
                possibilidade de tratamento posterior de forma incompatível com
                essas finalidades;
              </li>
              <li>
                Adequação: compatibilidade do tratamento com as finalidades
                informadas ao titular, de acordo com o contexto do tratamento;
              </li>
              <li>
                Necessidade: limitação do tratamento ao mínimo necessário para a
                realização de suas finalidades, com abrangência dos dados
                pertinentes, proporcionais e não excessivos em relação às
                finalidades do tratamento de dados;
              </li>
              <li>
                Livre acesso: garantia, aos titulares, de consulta facilitada e
                gratuita sobre a forma e a duração do tratamento, bem como sobre
                a integralidade de seus dados pessoais;
              </li>
              <li>
                Qualidade dos dados: garantia, aos titulares, de exatidão,
                clareza, relevância e atualização dos dados, de acordo com a
                necessidade e para o cumprimento da finalidade de seu
                tratamento;
              </li>
              <li>
                Transparência: garantia, aos titulares, de informações claras,
                precisas e facilmente acessíveis sobre a realização do
                tratamento e os respectivos agentes de tratamento, observados os
                segredos comercial e industrial;
              </li>
              <li>
                Segurança: utilização de medidas técnicas e administrativas
                aptas a proteger os dados pessoais de acessos não autorizados e
                de situações acidentais ou ilícitas de destruição, perda,
                alteração, comunicação ou difusão;
              </li>
              <li>
                Prevenção: adoção de medidas para prevenir a ocorrência de danos
                em virtude do tratamento de dados pessoais;
              </li>
              <li>
                Não discriminação: impossibilidade de realização do tratamento
                para fins discriminatórios ilícitos ou abusivos;
              </li>
              <li>
                Responsabilização e prestação de contas: demonstração, pelo
                agente, da adoção de medidas eficazes e capazes de comprovar a
                observância e o cumprimento das normas de proteção de dados
                pessoais e, inclusive, da eficácia dessas medidas.
              </li>
            </ul>

            <h2>5. BASE LEGAL:</h2>
            <p>
              5.1. A TRATAZ se compromete a garantir a legalidade no tratamento
              de dados pessoais, fundamentando suas operações nas seguintes
              bases legais, conforme estipulado pela LGPD e outras
              regulamentações aplicáveis:
            </p>
            <p>
              a) Consentimento: O titular dos dados concorda de forma explícita
              e inequívoca com o tratamento de seus dados pessoais para uma ou
              mais finalidades específicas. O consentimento é coletado de forma
              clara e distinta de outros termos, podendo ser revogado pelo
              titular a qualquer momento.
            </p>
            <p>
              b) Cumprimento de obrigação legal ou regulatória: O tratamento é
              necessário para que a TRATAZ cumpra uma obrigação legal ou
              regulatória a que está submetida, garantindo a aderência às leis e
              regulamentos do setor de saúde.
            </p>
            <p>
              c) Execução de contrato ou procedimentos preliminares relacionados
              a contrato: Quando o tratamento de dados pessoais é necessário
              para a execução de um contrato do qual o titular é parte, ou para
              procedimentos preliminares relacionados a um contrato.
            </p>
            <p>
              d) Proteção da vida ou da incolumidade física do titular ou de
              terceiros: Em situações em que o tratamento de dados pessoais se
              faz necessário para proteger a vida ou a segurança física do
              titular ou de terceiros.
            </p>
            <p>
              e) Tutela da saúde: Em consonância com as normas da ANVISA e dos
              Conselhos de Classe relacionados ao objeto da TRATAZ, o tratamento
              de dados relacionados à saúde pode ser realizado sem o
              consentimento do titular, mas sob a supervisão de profissionais da
              saúde, para garantir a prestação adequada de serviços de saúde.
            </p>
            <p>
              f) Legítimo interesse: A TRATAZ pode tratar dados pessoais com
              base em seus legítimos interesses, sempre de forma equilibrada e
              nunca sobrepondo os interesses, direitos fundamentais e liberdades
              do titular dos dados.
            </p>
            <p>
              g) Proteção ao crédito: Conforme previsto na legislação, o
              tratamento de dados pessoais também pode ocorrer para proteção ao
              crédito, uma base legal que permite à TRATAZ adotar procedimentos
              que assegurem a viabilidade financeira de suas operações.
            </p>
            <p>
              5.2. Para cada tratamento de dados pessoais realizado, a TRATAZ
              identifica claramente a base legal correspondente, assegurando a
              transparência e o direito de informação ao titular dos dados.
            </p>

            <h2>6. COMPARTILHAMENTO DE DADOS:</h2>
            <p>
              6.1. A TRATAZ reconhece a importância da privacidade dos dados
              pessoais e limita o compartilhamento de tais informações às
              situações necessárias, sempre observando as bases legais e
              garantindo a proteção adequada:
            </p>
            <p>
              a) Prestadores de Serviços e Parceiros: Dados pessoais podem ser
              compartilhados com parceiros ou prestadores de serviços que nos
              auxiliam na oferta e aprimoramento de nossos serviços, como
              empresas de tecnologia da informação, segurança de dados e suporte
              ao cliente. Todos os parceiros e prestadores de serviços são
              cuidadosamente selecionados e obrigados a seguir nossos padrões de
              segurança e privacidade.
            </p>
            <p>
              b) Transações Comerciais: Em casos de fusões, aquisições ou outras
              transações comerciais, dados pessoais podem ser transferidos como
              parte dos ativos da empresa, sempre respeitando a legislação
              aplicável e mantendo os titulares informados.
            </p>
            <p>
              c) Requisições Legais: A TRATAZ pode ser obrigada a compartilhar
              dados pessoais com autoridades governamentais ou judiciais em
              resposta a solicitações legais, dentro dos limites estabelecidos
              pela lei, assegurando a proteção dos direitos dos titulares.
            </p>
            <p>
              d) Com Consentimento: Além dos casos acima, qualquer outro
              compartilhamento de dados pessoais só será realizado com o
              consentimento explícito e informado do titular, que tem o direito
              de revogar tal consentimento a qualquer momento.
            </p>
            <p>
              e) Anonimização: Quando possível e relevante, os dados podem ser
              anonimizados antes do compartilhamento, de forma que não seja
              possível identificar o titular dos dados, especialmente em
              situações envolvendo análises estatísticas ou pesquisas de
              mercado.
            </p>
            <p>
              6.2. A TRATAZ compromete-se a garantir que qualquer
              compartilhamento de dados seja feito com a máxima segurança,
              respeitando as finalidades para as quais os dados foram coletados
              e em conformidade com a legislação aplicável.
            </p>
            <p>
              6.2.1. A empresa manterá os titulares informados sobre quaisquer
              mudanças em suas práticas de compartilhamento de dados através de
              atualizações nesta Política de Privacidade.
            </p>

            <h2>7. ÂMBITO DE APLICAÇÃO:</h2>
            <p>
              7.1. A presente Política é aplicável aos dados pessoais tratados
              por meio deste site ou e-mail de contato, e será cumprida pelo(s)
              administrador(es), diretor(es) e colaborador(es), assim como aos
              eventuais parceiros comerciais da TRATAZ.
            </p>
            <p>
              7.2. O(A) representante legal compromete-se a observar as
              previsões desta Política e a promover, sempre que possível, a
              aplicação de seus princípios.
            </p>

            <h2>8. TRANSFERÊNCIAS INTERNACIONAIS:</h2>
            <p>
              8.1. A TRATAZ pode transferir dados pessoais para países fora do
              Brasil em situações específicas, como o uso de servidores em nuvem
              localizados em outros países ou quando houver necessidade de
              compartilhamento com parceiros internacionais.
            </p>
            <p>
              8.2. Nos casos de transferência internacional, a TRATAZ adotará
              todas as medidas necessárias para garantir que seus dados estejam
              protegidos de acordo com os padrões da LGPD e outras legislações
              aplicáveis.
            </p>

            <h2>9. DIREITOS DOS TITULARES DE DADOS PESSOAIS:</h2>
            <p>
              9.1. A todas as pessoas estão assegurados a titularidade de seus
              dados pessoais e garantidos os direitos fundamentais de liberdade,
              intimidade e privacidade, nos termos da LGPD (Lei Geral de
              Proteção de Dados – Lei nº 13.709/18).
            </p>
            <p>
              9.2. O titular dos dados pessoais tem direito, em relação aos
              dados tratados pela TRATAZ, a qualquer momento e mediante
              requisição para:
            </p>
            <p>
              a) Confirmação da existência de tratamento;
              <br />
              b) Acesso aos dados;
              <br />
              c) Correção de dados incompletos, inexatos ou desatualizados;
              <br />
              d) Anonimização, bloqueio ou eliminação de dados desnecessários,
              excessivos ou tratados em desconformidade com o disposto na LGPD;
              <br />
              e) Portabilidade dos dados a outro fornecedor de serviço ou
              produto, mediante requisição expressa, após a devida
              regulamentação da autoridade nacional, observados os segredos
              comercial e industrial;
              <br />
              f) Eliminação dos dados pessoais tratados com o consentimento do
              titular, exceto nas hipóteses previstas no art. 16, da LGPD;
              <br />
              g) Informação das entidades públicas e privadas com as quais
              realizou uso compartilhado de dados;
              <br />
              h) Informação sobre a possibilidade de não fornecer consentimento
              e sobre as consequências da negativa;
              <br />
              i) Revogação do consentimento, caso esta seja a hipótese de
              tratamento utilizada pela TRATAZ.
            </p>

            <h2>10. SEGURANÇA DOS DADOS:</h2>
            <p>
              10.1. Na TRATAZ, levamos a segurança dos seus dados pessoais e de
              saúde extremamente a sério. Implementamos uma série de medidas de
              segurança técnica e organizacional para proteger seus dados contra
              acesso, divulgação, alteração ou destruição não autorizada.
            </p>
            <p>
              10.2. Aqui estão as principais medidas que adotamos para garantir
              a segurança e a integridade das suas informações:
            </p>

            <h3>10.2.1. Criptografia de Dados:</h3>
            <p>
              Todos os dados transmitidos e armazenados em nossos sistemas são
              protegidos usando tecnologia de criptografia de ponta a ponta,
              assegurando que suas informações sejam acessíveis apenas por
              pessoas autorizadas.
            </p>

            <h3>10.2.2. Controle de Acesso:</h3>
            <p>
              Implementamos controles de acesso estritos, onde somente pessoal
              autorizado pode acessar informações sensíveis. A autenticação
              multifatorial é um requisito para todos os nossos funcionários e
              colaboradores que acessam sistemas contendo dados de saúde.
            </p>

            <h3>10.2.3. Monitoramento e Detecção de Intrusão:</h3>
            <p>
              Nossos sistemas são monitorados continuamente para detectar e
              responder prontamente a qualquer atividade suspeita, ajudando a
              prevenir qualquer potencial violação de segurança.
            </p>

            <h3>10.2.4. Gerenciamento de Vulnerabilidades:</h3>
            <p>
              Realizamos avaliações regulares e testes de penetração para
              identificar e corrigir proativamente quaisquer vulnerabilidades em
              nossos sistemas e aplicações.
            </p>

            <h3>10.2.5. Segurança Física:</h3>
            <p>
              Nossos servidores e infraestrutura de TI estão localizados em
              instalações seguras, com acesso controlado para prevenir acessos
              físicos não autorizados.
            </p>

            <h3>10.2.6. Políticas de Privacidade e Segurança de Dados:</h3>
            <p>
              Mantemos políticas internas rigorosas de privacidade e segurança
              de dados, garantindo que nossa equipe esteja plenamente consciente
              de suas responsabilidades em proteger suas informações.
            </p>

            <h3>10.2.7. Treinamento de Conscientização em Segurança:</h3>
            <p>
              Todos os nossos funcionários recebem treinamento regular sobre
              práticas seguras de manuseio de dados e conscientização sobre
              ameaças cibernéticas.
            </p>

            <h3>10.2.8. Plano de Resposta a Incidentes:</h3>
            <p>
              Possuímos um plano de resposta a incidentes para lidar com
              eventuais violações de segurança, permitindo uma reação rápida e
              efetiva para minimizar qualquer impacto sobre seus dados.
            </p>

            <h3>10.2.9. Backup e Recuperação de Dados:</h3>
            <p>
              Efetuamos backups regulares para garantir a restauração eficiente
              de dados em caso de perda ou dano, protegendo a continuidade do
              acesso às suas informações.
            </p>

            <h3>10.2.10. Conformidade com Normas de Segurança:</h3>
            <p>
              Estamos em conformidade com as normas e regulamentos de segurança
              de dados aplicáveis, reforçando nosso compromisso com a proteção e
              privacidade das suas informações.
            </p>

            <h3>10.2.11. Comprometimento:</h3>
            <p>
              Levamos a sua privacidade muito a sério e estamos comprometidos em
              proteger suas informações. Se tiver alguma dúvida ou preocupação
              sobre como seus dados são protegidos, não hesite em entrar em
              contato conosco.
            </p>

            <p>
              10.3. A Controladora é responsável pelas medidas de segurança
              técnicas e administrativas aptas a proteger os dados pessoais de
              acessos não autorizados e de situações acidentais ou ilícitas de
              destruição, perda, alteração, comunicação ou qualquer forma de
              tratamento inadequado ou ilícito.
            </p>

            <p>
              10.4. Em conformidade ao art. 48 da LGPD, a Controladora
              comunicará ao Titular e à Autoridade Nacional de Proteção de Dados
              (ANPD) a ocorrência de incidente de segurança que possa acarretar
              risco ou dano relevante ao Titular.
            </p>

            <h2>11. RETENÇÃO DE DADOS:</h2>
            <p>
              11.1. A TRATAZ está comprometida com o princípio da minimização do
              armazenamento, garantindo que os dados pessoais sejam retidos
              apenas pelo tempo necessário para cumprir as finalidades para as
              quais foram coletados, respeitando as seguintes diretrizes:
            </p>
            <p>
              a) Período de Retenção: Os dados pessoais serão mantidos enquanto
              a conta do usuário estiver ativa ou enquanto for necessário para
              fornecer os serviços. Adicionalmente, alguns dados podem ser
              retidos por períodos mais extensos quando exigido por obrigações
              legais, fiscais ou regulatórias, ou para fins de proteção em caso
              de disputas legais.
            </p>
            <p>
              b) Critérios para Definição de Prazos: Os prazos de retenção são
              baseados em critérios como a natureza e a sensibilidade dos dados,
              as finalidades para as quais são tratados, os requisitos legais
              aplicáveis e as possíveis necessidades de retenção para proteção
              legal ou conformidade regulatória.
            </p>
            <p>
              c) Revisão dos Prazos de Retenção: A TRATAZ revisará
              periodicamente os prazos de retenção de dados pessoais com base
              nos critérios estabelecidos para garantir que os dados sejam
              retidos apenas pelo tempo necessário para cumprir as finalidades
              para as quais foram coletados e para atender a qualquer obrigação
              legal ou regulatória aplicável.
            </p>
          </Text>
        </ContentWithPaddingXl>
      </Container>
      <Footer />
    </AnimationRevealPage>
  );
};
